"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const ParentNotConnectedToChild_1 = require("./errors/ParentNotConnectedToChild");
const StudentHasNoReports_1 = require("./errors/StudentHasNoReports");
const StudentReportNotFound_1 = require("./errors/StudentReportNotFound");
const TeacherCannotAccessClass_1 = require("./errors/TeacherCannotAccessClass");
class StudentReportCardsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async fetchChildReportCards({ childId, limit, lastKey }) {
        const queryParams = this.encodeQueryParams({ limit, lastKey });
        const url = `${this.url}/api/parent/child/${childId}/report-cards?${queryParams}`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 403, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new ParentNotConnectedToChild_1.ParentNotConnectToChildError(childId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async fetchChildReportCard({ childId, reportId, createdAt }) {
        const url = `${this.url}/api/parent/child/${childId}/report-cards/${reportId}/${createdAt}`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 403, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new ParentNotConnectedToChild_1.ParentNotConnectToChildError(childId);
        }
        if (response.status === 404) {
            throw new StudentReportNotFound_1.StudentReportNotFound(childId, reportId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async markReportCardViewed({ childId, reportId, createdAt }) {
        const url = `${this.url}/api/parent/child/${childId}/report-cards/${reportId}/${createdAt}/viewed`;
        const options = { method: 'POST' };
        const expectedResponses = [204, 403, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new ParentNotConnectedToChild_1.ParentNotConnectToChildError(childId);
        }
        if (response.status === 404) {
            throw new StudentReportNotFound_1.StudentReportNotFound(childId, reportId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
    }
    async sendStudentReports(body) {
        const url = `${this.url}/api/teacher/send-student-reports`;
        const options = {
            method: 'POST',
            body: JSON.stringify(body)
        };
        const expectedResponses = [200, 400, 422, 403];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new TeacherCannotAccessClass_1.TeacherCannotAccessClass(body.classId);
        }
        if (response.status === 400 || response.status === 422) {
            throw new Error('Invalid request parameters');
        }
    }
    async sendClassReports(body) {
        const url = `${this.url}/api/teacher/send-class-reports`;
        const options = {
            method: 'POST',
            body: JSON.stringify(body)
        };
        const expectedResponses = [200, 400, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400 || response.status === 422) {
            throw new Error('Invalid request parameters');
        }
    }
    async fetchLastSentStudentReport({ classId, studentId }) {
        const url = `${this.url}/api/teacher/class/${classId}/student/${studentId}/last-sent-report`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 403, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new TeacherCannotAccessClass_1.TeacherCannotAccessClass(classId);
        }
        if (response.status === 404) {
            throw new StudentHasNoReports_1.StudentHasNoReports(studentId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async fetchStudentMostRecentReport({ classId, studentId }) {
        const url = `${this.url}/api/teacher/class/${classId}/student/${studentId}/most-recent-report`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 403, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new TeacherCannotAccessClass_1.TeacherCannotAccessClass(classId);
        }
        if (response.status === 404) {
            throw new StudentHasNoReports_1.StudentHasNoReports(studentId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async fetchStudentSectionStats({ classId, studentId, assignmentIds }) {
        const url = `${this.url}/api/teacher/class/${classId}/student/${studentId}/section-stats`;
        const options = {
            method: 'POST',
            body: JSON.stringify({
                assignmentIds
            })
        };
        const expectedResponses = [200, 403, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new TeacherCannotAccessClass_1.TeacherCannotAccessClass(classId);
        }
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    encodeQueryParams(params) {
        return Object.entries(params)
            .flatMap(([key, value]) => value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : [])
            .join('&');
    }
}
exports.default = StudentReportCardsServiceClient;
//# sourceMappingURL=StudentReportCardsServiceClient.js.map